import React from 'react';

import CtaWithHint from 'components/CtaWithHint';
import LegalPageLayout from 'components/LegalPageLayout';
import LocalizedLink from 'components/LocalizedLink';
import TrustProof from 'components/TrustProof';
import { useI18n } from 'i18n/I18nContext';

const ROWS = ['progress', 'cash', 'recipes', 'ai', 'team', 'paper'] as const;

const ComparePage = () => {
  const { t } = useI18n();

  return (
    <LegalPageLayout title={t('compare.title')} lede={t('compare.intro')} variant="marketing" wide>
      <div className="gb-compare-scroll mb-50">
        <table className="gb-compare-table">
          <caption className="sr-only">{t('compare.tableCaption')}</caption>
          <thead>
            <tr>
              <th scope="col">{t('compare.colTopic')}</th>
              <th scope="col">{t('compare.colPaper')}</th>
              <th scope="col">{t('compare.colGeneric')}</th>
              <th scope="col">{t('compare.colGastro')}</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row) => (
              <tr key={row}>
                <th scope="row">{t(`compare.rows.${row}.topic`)}</th>
                <td>{t(`compare.rows.${row}.paper`)}</td>
                <td>{t(`compare.rows.${row}.generic`)}</td>
                <td className="gb-compare-table__highlight">{t(`compare.rows.${row}.gastro`)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="mb-35 gb-prose-muted">{t('compare.disclaimer')}</p>

      <div className="gb-resource-cta">
        <CtaWithHint href="/onboard" buttonLabel={t('compare.cta')} hint={t('compare.ctaHint')} />
        <TrustProof className="mt-25" />
        <p className="mt-35 mb-0">
          <LocalizedLink className="text-green font-bold no-underline" to="/checklist">
            {t('compare.checklistLink')}
          </LocalizedLink>
        </p>
      </div>
    </LegalPageLayout>
  );
};

export default ComparePage;



// WEBPACK FOOTER //
// ./src/pages/ComparePage.tsx